// extracted by mini-css-extract-plugin
module.exports = {"categoriesContainer":"CategoryDetailContainer_categoriesContainer__3gzs0","sidebar":"CategoryDetailContainer_sidebar__18h9y"};